<template>
  <div class="container-fluid register-wrapper">
    <div class="register-container">

      <!-- HEADER -->
      <div class="auth-header">
        <div class="brand">
          <router-link :to="{ name: 'login' }" class="logo-link">
            <img src="../assets/images/logo/logo.png" alt="TusCFDI" height="32" />
          </router-link>
        </div>
        <div class="auth-link">
          <span>¿Ya tienes cuenta?</span>
          <router-link :to="{ name: 'login' }" class="btn btn-outline-primary btn-sm">
            Iniciar sesión
          </router-link>
        </div>
      </div>

      <!-- CONTENT -->
      <div class="row justify-content-center align-items-center min-vh-100 pt-5">
        <div class="col-xl-9 col-lg-10">
          <div class="register-card">

            <!-- LEFT -->
            <div class="register-left">
              <span class="badge mb-4">Tu mejor Opción</span>

              <h1>
                Tu información fiscal en tiempo real.
              </h1>
              <p>
                Descarga, organiza y analiza automaticamente todos tus CFDIs.
              </p>
              <br>
              <p>
                Anticipa cuánto pagarás antes de declarar
              </p>
              <div class="trust mt-auto">
                <div class="avatars"></div>
                <span>Descubre una mejor forma de visualizar tus CFDIs</span>
              </div>
            </div>

            <!-- RIGHT -->
            <div class="register-right">
              <h2>Crear cuenta</h2>
              <p class="text-muted mb-4">
                Completa los datos para comenzar tu prueba gratuita de 12 días.
              </p>
              <form class="theme-form" @submit.prevent="submit">
                <div v-if="formError" class="alert alert-danger" role="alert">{{ formError }}</div>

                <!-- NOMBRE -->
                <div class="form-group mb-3">
                  <label>Nombre completo</label>
                  <input type="text" class="form-control form-control-lg" placeholder="Juan Pérez" v-model="form.name"
                    @input="normalizeName" @blur="v$.form.name.$touch()" :class="{ 'is-invalid': v$.form.name.$error }" />
                  <div class="invalid-feedback d-block" v-if="v$.form.name.$error">
                    <span v-if="v$.form.name.$errors.length">
                      {{ v$.form.name.$errors[0].$message }}
                    </span>
                  </div>
                </div>

                <div class="row">

                  <!-- EMAIL -->
                  <div class="col-md-6 form-group mb-3">
                    <label>Correo electrónico</label>
                    <input type="email" class="form-control form-control-lg" placeholder="juan@empresa.com"
                      v-model="form.email" @input="normalizeEmail" @blur="v$.form.email.$touch()"
                      :class="{ 'is-invalid': v$.form.email.$error }" />
                    <div class="invalid-feedback" v-if="v$.form.email.$error">
                      <span v-if="v$.form.email.$errors.length">
                        {{ v$.form.email.$errors[0].$message }}
                      </span>
                    </div>
                  </div>

                  <!-- WHATSAPP -->
                  <div class="col-md-6 form-group mb-3">
                    <label>Whatsapp</label>
                    <input type="tel" class="form-control form-control-lg" placeholder="5512345678 o +14155552671"
                      v-model="form.phone" @blur="v$.form.phone.$touch()"
                      :class="{ 'is-invalid': v$.form.phone.$error }" />
                   <div class="invalid-feedback d-block" v-if="v$.form.phone.$error">
                    <span v-if="v$.form.phone.$errors.length">
                      {{ v$.form.phone.$errors[0].$message }}
                    </span>
                  </div>
                  </div>

                </div>

                <div class="row">

                  <!-- PASSWORD -->
                  <div class="col-md-6 form-group mb-3">
                    <label>Contraseña</label>
                    <div class="position-relative">
                      <input :type="showPassword ? 'text' : 'password'" class="form-control form-control-lg pe-5"
                        placeholder="••••••••" v-model="form.password" @blur="v$.form.password.$touch()"
                        :class="{ 'is-invalid': v$.form.password.$error }" />
                      <span class="toggle-password" @click="showPassword = !showPassword">
                        👁
                      </span>
                    </div>
                    <div class="invalid-feedback d-block" v-if="v$.form.password.$error">
                      <span v-if="v$.form.password.$errors.length">
                        {{ v$.form.password.$errors[0].$message }}
                      </span>
                    </div>
                  </div>

                  <!-- CONFIRM PASSWORD -->
                  <div class="col-md-6 form-group mb-3">
                    <label>Confirmar contraseña</label>
                    <input type="password" class="form-control form-control-lg" placeholder="••••••••"
                      v-model="form.passwordConfirm" @blur="v$.form.passwordConfirm.$touch()"
                      :class="{ 'is-invalid': v$.form.passwordConfirm.$error }" />
                    <div class="invalid-feedback" v-if="v$.form.passwordConfirm.$error">
                      <span v-if="v$.form.passwordConfirm.$errors.length">
                        {{ v$.form.passwordConfirm.$errors[0].$message }}
                      </span>
                    </div>
                  </div>

                </div>

                <div class="form-group mb-4">
                  <input type="checkbox" class="checkbox_animated me-2" v-model="form.acceptTerms" @change="v$.form.acceptTerms.$touch()" />
                  <span>
                    Acepto los
                    <a href="https://tuscfdis.com/terminos">Términos de Servicio</a>
                    y la
                    <a href="https://tuscfdis.com/politica-privacidad">Política de Privacidad</a>
                    de TusCFDI.
                  </span>
                  <div class="invalid-feedback d-block" v-if="v$.form.acceptTerms.$error">
                    {{ v$.form.acceptTerms.$errors[0].$message }}
                  </div>
                </div>

                <button class="btn btn-primary btn-lg w-100">
                  Continuar
                </button>

                <div class="divider my-4">
                  <span>O ENTRAR CON</span>
                </div>

                <button type="button" class="btn btn-light btn-lg w-100 google-btn" @click="startGoogleAuth">
                  <img src="../assets/images/svg-icon/google.svg" alt="Google" />
                  <span>Google</span>
                </button>

              </form>

            </div>

          </div>
        </div>
      </div>

      <!-- FOOTER -->
      <div class="auth-footer">
        <div class="footer-links">
          <a target="_blank" href="https://tuscfdis.com/terminos">Términos</a>
          <a target="_blank" href="https://tuscfdis.com/politica-privacidad">Privacidad</a>
        </div>
        <small>© 2026 TusCFDIs.</small>
      </div>
    </div>
  </div>
</template>

<script>
import ws from '@/services/login';
import { pushGtmEvent } from '@/services/gtm';
import { normalizeEmail, normalizeName } from '@/mixins/normalizers';
import { useVuelidate } from '@vuelidate/core'
import { required, email, minLength, sameAs, helpers } from '@vuelidate/validators';
import moment from 'moment';

const normalizeWhatsappInput = (value) => String(value || '').trim().replace(/[\s()-]/g, '')

const whatsappFormat = helpers.withMessage(
  'Captura un WhatsApp válido: 10 dígitos o formato internacional con +',
  (value) => {
    const normalized = normalizeWhatsappInput(value)
    if (!normalized) return false

    if (normalized.startsWith('+')) {
      const digits = normalized.slice(1)
      return /^\d+$/.test(digits) && digits.length >= 8
    }

    return /^\d{10}$/.test(normalized)
  }
)

export default {
  name: 'register',
  data() {
    return {
      showPassword: false,
      formError: '',
      form: {
        name: '',
        email: '',
        phone: '',
        password: '',
        passwordConfirm: '',
        acceptTerms: false
      }
    }
  },
  validations() {
    return {
      form: {
        name: { 
          required: helpers.withMessage('El nombre es obligatorio', required),
          minLength: helpers.withMessage('El nombre debe tener al menos 3 caracteres', minLength(3)) },
        email: { required: helpers.withMessage('El correo es obligatorio', required), email: helpers.withMessage('Correo inválido', email) },
        phone: {
          required: helpers.withMessage('El WhatsApp es obligatorio', required),
          whatsappFormat,
        },
        password: { required: helpers.withMessage('La contraseña es obligatoria', required), minLength: helpers.withMessage('Mínimo 8 caracteres', minLength(8)) },
        passwordConfirm: { required: helpers.withMessage('Confirma tu contraseña', required), sameAsPassword: helpers.withMessage('Las contraseñas no coinciden', sameAs(this.form.password)) },
        acceptTerms: { required: helpers.withMessage('Debes aceptar los términos', sameAs(true))}
      }
    }
  },
  setup() {
    const v$ = useVuelidate()
    return { v$ }
  },
  mounted() {
    pushGtmEvent('registration_form_view', {
      screen_name: 'register',
      flow: 'email_registration',
    })

    this.processGoogleAuthFromHash()
  },
  methods: {
    showWhatsappTakenToast(message) {
      const normalized = String(message || '').trim()
      if (normalized !== 'Este número de WhatsApp ya está vinculado a otra cuenta.') {
        return
      }

      this.$toast.error('Este número de WhatsApp ya está vinculado a otra cuenta.')
    },
    getGoogleClientId() {
      return String(process.env.VUE_APP_GOOGLE_CLIENT_ID || '').trim()
    },
    generateOAuthState() {
      return Math.random().toString(36).slice(2) + Date.now().toString(36)
    },
    async processGoogleAuthFromHash() {
      this.formError = ''
      const hash = String(window.location.hash || '')
      if (!hash.startsWith('#')) return

      const params = new URLSearchParams(hash.slice(1))
      const idToken = params.get('id_token')
      const state = params.get('state')
      const error = params.get('error')

      if (!idToken && !error) return

      window.history.replaceState({}, document.title, `${window.location.pathname}${window.location.search}`)

      if (error) {
        this.formError = 'No fue posible autenticar con Google'
        return
      }

      const expectedState = sessionStorage.getItem('google_oauth_state')
      sessionStorage.removeItem('google_oauth_state')

      if (!expectedState || state !== expectedState) {
        this.formError = 'La sesión de Google no es válida, intenta nuevamente'
        return
      }

      await this.loginWithGoogleIdToken(idToken)
    },
    startGoogleAuth() {
      this.formError = ''
      const clientId = this.getGoogleClientId()
      if (!clientId) {
        this.formError = 'Google OAuth no está configurado. Falta VUE_APP_GOOGLE_CLIENT_ID'
        return
      }

      const state = this.generateOAuthState()
      const nonce = this.generateOAuthState()
      const redirectUri = `${window.location.origin}${window.location.pathname}`

      sessionStorage.setItem('google_oauth_state', state)

      const authUrl = new URL('https://accounts.google.com/o/oauth2/v2/auth')
      authUrl.searchParams.set('client_id', clientId)
      authUrl.searchParams.set('redirect_uri', redirectUri)
      authUrl.searchParams.set('response_type', 'id_token')
      authUrl.searchParams.set('scope', 'openid email profile')
      authUrl.searchParams.set('prompt', 'select_account')
      authUrl.searchParams.set('nonce', nonce)
      authUrl.searchParams.set('state', state)

      window.location.assign(authUrl.toString())
    },
    applySession(data) {
      const token = data.token
      const user = data.user

      localStorage.setItem('access_token', token)
      localStorage.setItem('user', JSON.stringify(user))
      localStorage.setItem('rfcs', JSON.stringify(user.rfcs || []))
      localStorage.setItem('period', moment().format("YYYY-MM"))

      if (user.rfc) {
        localStorage.setItem('rfc', user.rfc.rfc)
        localStorage.setItem('fiscal_name', user.rfc.name)
        this.$router.push({ name: 'dashboard' })
      } else {
        localStorage.setItem('rfc', "")
        localStorage.setItem('fiscal_name', "")
        this.$router.push({ name: 'settings', query: { section: 'rfcs' } })
      }
    },
    async loginWithGoogleIdToken(idToken) {
      this.formError = ''
      this.$loading.show()
      try {
        const response = await ws.loginGoogle(idToken)
        if (response.type !== 'success') {
          this.formError = response.message
          return
        }

        this.applySession(response.data)
      } catch (e) {
        this.formError = 'Error al iniciar sesión con Google'
      } finally {
        this.$loading.hide()
      }
    },
    normalizeName() {
      this.form.name = normalizeName(this.form.name)
    },
    normalizeEmail() {
      this.form.email = normalizeEmail(this.form.email)
    },
    async submit() {
      this.formError = ''
      this.normalizeName()
      this.normalizeEmail()

      this.v$.$touch()

      if (this.v$.$invalid) return

      this.$loading.show();
      try {
        const payload = {
          ...this.form,
          name: normalizeName(this.form.name),
          email: normalizeEmail(this.form.email)
        }

        const res = await ws.register(payload)
        if (res.type !== 'success') {
          this.showWhatsappTakenToast(res.message)
          this.formError = res.message
          return
        }

        this.$router.push({
          name: 'verifyAccount',
          query: { email: payload.email }
        })

        pushGtmEvent('registration_verification_form_redirect', {
          screen_name: 'verify_account',
          flow: 'email_registration',
        })

      } catch (e) {
        const apiMessage = e?.response?.data?.message || ''
        this.showWhatsappTakenToast(apiMessage)
        this.formError = apiMessage || 'Error inesperado'
      } finally {
        this.$loading.hide();
      }

    }
  }
}

</script>
